import { useEffect, useState } from "react";
import { ArrowLeft, Eye } from "@phosphor-icons/react";
import api from "@/lib/api";

const hasToken = () => typeof localStorage !== "undefined" && !!localStorage.getItem("gestaocv_token");

/** Thin bar only the site owner sees when previewing their own public site. Visitors never get it. */
export function OwnerBar({ slug }) {
  const [mine, setMine] = useState(false);
  useEffect(() => {
    if (!hasToken()) return;
    api.get("/site/settings").then(({ data }) => setMine(data.slug === slug)).catch(() => {});
  }, [slug]);
  if (!mine) return null;
  return (
    <>
      <div className="fixed inset-x-0 top-0 z-[60] flex h-9 items-center gap-3 bg-zinc-900/95 px-3 text-xs text-white backdrop-blur" data-testid="owner-bar">
        <a href="/meu-site" className="flex items-center gap-1 rounded-full bg-white/10 px-3 py-1 font-semibold hover:bg-white/20" data-testid="owner-bar-back"><ArrowLeft size={14} /> Voltar ao painel</a>
        <span className="flex items-center gap-1 text-white/80"><Eye size={14} /> Pré-visualização do seu site</span>
      </div>
      <div className="h-9" aria-hidden="true" />
    </>
  );
}
